import React from "react";

function ThreeFactCon({ img, title, description }) {
  return (
    <div className="w-full flex gap-1 flex-col items-center">
      <img src={img} alt="" className="w-12" />
      <h1 className="mt-2 font-medium text-lg text-center">{title}</h1>
      <p className="text-gray-500 text-center text-lg">{description}</p>
    </div>
  );
}

export default ThreeFactCon;
